import moment from "moment";

export const datetime_from_server = value => {
  return new Date(value);
};

export const datetime_to_server = value => {
  return moment(value).format();
};
